/**
 * reportedPeptidesForSingleSearch_ChildReactComponents_Other.tsx
 *
 *  "Other" React Components for use when creating reportedPeptidesForSingleSearch_ChildReactComponent.tsx
 *
 */

import React from "react";

/**
 *
 */
const uniqueColumnHeader_Tooltip_Create = function () : React.JSX.Element {

    return (

        <div >
            Indicates if peptide is only found in this protein
        </div>
    );
}


/**
 *
 */
export const reportedPeptidesForSingleSearch_ChildReactComponents_Other = {

    uniqueColumnHeader_Tooltip_Create
}


